<mat-card
    class="mb-25 tagus-card add-user-wrapper angila-form position-relative"
>
    <mat-card-header>
        <h3 class="py-4 px-4">
            <strong>
                Hello, my name is {{user_details?.name}}, I will be conducting your
                Final/Mock interview today. Can you please show me your
                passport?
            </strong>
        </h3>
    </mat-card-header>

    <mat-card-content>
        <form [formGroup]="interviewForm" (ngSubmit)="onSubmit()">
            <div formArrayName="radioQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('radioQuestions')
                            .controls;
                        let i = index
                    "
                    [formGroupName]="i"
                >
                    <div class="row fw-semibold pb-5">
                        <label class="col-sm-4 label-center">
                            {{ radioQuestionArr[i].question }}
                            <b
                                class="color-red"
                                *ngIf="radioQuestionArr[i]?.isRequired"
                                >*</b
                            >
                        </label>
                        <div class="col-sm-6">
                            <div class="d-flex gap-x-2">
                                <ng-container
                                    *ngFor="
                                        let option of radioQuestionArr[i]
                                            .options
                                    "
                                >
                                    <input
                                        type="radio"
                                        [id]="option?.id"
                                        [value]="option?.value"
                                        formControlName="answer"
                                        (change)="onChanges(group, i)"
                                    />
                                    <label
                                        [for]="option?.id"
                                        class="cursor-pointer"
                                    >
                                        {{ option?.label }}
                                    </label>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <ng-container
                        formArrayName="subQuestions"
                        *ngIf="group.get('subQuestions').controls.length > 0"
                    >
                        <div class="row border pb-10 mb-15">
                            <div
                                class="col-sm-12 px-4 py-4 bg-blue text-white fw-semibold fs-14"
                            >
                                {{ radioQuestionArr[i].subQuestionLabel.label }}
                            </div>
                            <div
                                *ngFor="
                                    let subGroup of group.get('subQuestions')
                                        .controls;
                                    let j = index
                                "
                                [formGroupName]="j"
                                class="row fw-semibold pb-5 mb-5 py-2"
                            >
                                <div class="col-sm-4 label-center">
                                    {{ j + 1 }}.
                                    {{
                                        radioQuestionArr[i].subQuestions[j]
                                            .question
                                    }}
                                    <b
                                        class="color-red"
                                        *ngIf="
                                            radioQuestionArr[i].subQuestions[j]
                                                ?.isRequired
                                        "
                                        >*</b
                                    >
                                </div>
                                <div class="col-sm-8">
                                    <div class="d-flex gap-x-2">
                                        <ng-container
                                            *ngFor="
                                                let subOption of radioQuestionArr[
                                                    i
                                                ].subQuestions[j].options
                                            "
                                        >
                                            <input
                                                type="radio"
                                                [id]="subOption?.id"
                                                [value]="subOption?.value"
                                                formControlName="answer"
                                            />
                                            <label
                                                [for]="subOption?.id"
                                                class="cursor-pointer"
                                            >
                                                {{ subOption?.label }}
                                            </label>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div formArrayName="compulsoryQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('compulsoryQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <div class="row mt-15">
                        <div
                            class="col-sm-12 py-4 bg-blue text-white fw-semibold fs-20"
                        >
                            {{ interviewQuestions[i].primary.heading }}
                        </div>

                        <div class="col-sm-12 px-4 py-4 fw-semibold fs-20">
                            {{ interviewQuestions[i].primary.label }}
                        </div>
                    </div>

                    <div class="row bg-grey">
                        <div class="col-sm-4 border py-4">
                            <b>Question</b>
                        </div>
                        <div class="col-sm-6 border py-4">
                            <b>Is the student able to explain clearly? </b>
                        </div>
                        <div class="col-sm-2 border py-4">
                            <b> Decision </b>
                        </div>
                    </div>
                    <div [formGroupName]="i">
                        <ng-container formArrayName="questionList">
                            <div
                                class="row"
                                *ngFor="
                                    let item of group.get('questionList')
                                        .controls;
                                    let k = index
                                "
                                [formGroupName]="k"
                            >
                                <div class="col-sm-4 border py-4">
                                    {{
                                        interviewQuestions[i].questionList[k]
                                            .question
                                    }}
                                </div>
                                <div class="col-sm-6 border py-4">
                                    {{
                                        interviewQuestions[i].questionList[k]
                                            .subQuestions[0].questions
                                    }}
                                </div>
                                <div class="col-sm-2 border py-4">
                                    <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                    >
                                        <mat-label>Select Decision</mat-label>
                                        <mat-select
                                            formControlName="decision"
                                            class="form-control"
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let riskFactor of interviewQuestions[0]
                                                        ?.primary?.decisions
                                                "
                                                [value]="riskFactor?.value"
                                            >
                                                {{ riskFactor?.value }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div formArrayName="additionalQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('additionalQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <div class="row mt-15">
                        <div
                            class="col-sm-12 py-4 bg-blue text-white fw-semibold fs-20"
                        >
                            {{ additionalQuestions[i].primary.heading }}
                        </div>
                    </div>

                    <div class="row bg-grey">
                        <div class="col-sm-3 border py-4">
                            <b>Additional Information Question</b>
                        </div>
                        <div class="col-sm-2 border py-4">
                            <b>Is the student able to explain clearly?</b>
                        </div>
                        <div class="col-sm-5 border py-4">
                            <b>Please add appropriate Notes</b>
                        </div>
                        <div class="col-sm-2 border py-4">
                            <b> Decision </b>
                        </div>
                    </div>
                    <div [formGroupName]="i">
                        <ng-container formArrayName="additionalQuestionList">
                            <div
                                class="row"
                                *ngFor="
                                    let item of group.get(
                                        'additionalQuestionList'
                                    ).controls;
                                    let k = index
                                "
                                [formGroupName]="k"
                            >
                                <div
                                    class="col-sm-3 border py-4"
                                    [innerHTML]="
                                        additionalQuestions[i].questionList[k]
                                            .question
                                    "
                                ></div>
                                <div class="col-sm-2 border py-4">
                                    {{
                                        additionalQuestions[i].questionList[k]
                                            .subQuestions[0].questions
                                    }}
                                </div>
                                <ng-container
                                    *ngIf="
                                        additionalQuestions[i].questionList[k]
                                            .subQuestions[0]?.answerType ===
                                        'textarea'
                                    "
                                >
                                    <div class="col-sm-5 border py-4">
                                        <quill-editor
                                            [styles]="{ height: '150px' }"
                                            name="html"
                                            placeholder="Write answer..."
                                            formControlName="answer"
                                            [modules]="QuillModules"
                                        ></quill-editor>
                                    </div>
                                    <div class="col-sm-2 border py-4">
                                        <mat-form-field
                                            appearance="outline"
                                            class="w-100"
                                        >
                                            <mat-label
                                                >Select Decision</mat-label
                                            >
                                            <mat-select
                                                formControlName="decision"
                                                class="form-control"
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let riskFactor of interviewQuestions[0]
                                                            ?.primary?.decisions
                                                    "
                                                    [value]="riskFactor?.value"
                                                >
                                                    {{ riskFactor?.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </ng-container>
                                <div
                                    class="col-sm-7 border py-4"
                                    *ngIf="
                                        additionalQuestions[i].questionList[k]
                                            .subQuestions[0]?.answerType ===
                                        'options'
                                    "
                                >
                                    <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                    >
                                        <mat-select
                                            formControlName="answer"
                                            class="form-control"
                                        >
                                            <mat-option disabled value=""
                                                >--{{
                                                    additionalQuestions[i]
                                                        .questionList[k]
                                                        .subQuestions[0]?.label
                                                }}--</mat-option
                                            >
                                            <mat-option
                                                *ngFor="
                                                    let riskFactor of additionalQuestions[
                                                        i
                                                    ].questionList[k]
                                                        .subQuestions[0]
                                                        ?.options
                                                "
                                                [value]="riskFactor?.value"
                                            >
                                                {{ riskFactor?.value }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div formArrayName="compulsoryQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('compulsoryQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <ng-contianer [formGroupName]="i">
                        <div class="row py-4">
                            <div
                                class="col-sm-12"
                                formGroupName="releventInformation"
                            >
                                <div class="row py-4">
                                    <div class="col-sm-12">
                                        {{
                                            interviewQuestions[i]
                                                .releventInformation.question
                                        }}
                                    </div>
                                    <div class="col-sm-12">
                                        <quill-editor
                                            [styles]="{ height: '150px' }"
                                            name="html"
                                            placeholder="Write answer..."
                                            formControlName="answer"
                                            [modules]="QuillModules"
                                        ></quill-editor>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6" formGroupName="riskScore">
                                <div class="row py-4">
                                    <div class="col-sm-6">
                                        {{
                                            interviewQuestions[i].riskScore
                                                .question
                                        }}
                                    </div>

                                    <div class="col-sm-6">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Risk Score</mat-label>
                                            <input
                                                matInput
                                                formControlName="answer"
                                            />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="col-sm-6"
                                formGroupName="casRecommended"
                            >
                                <div class="row py-4">
                                    <div class="col-sm-6">
                                        {{
                                            interviewQuestions[i].casRecommended
                                                .question
                                        }}
                                    </div>

                                    <div class="col-sm-6">
                                        <mat-form-field
                                            appearance="outline"
                                            class="w-100"
                                        >
                                            <mat-label
                                                >Select
                                                Recommendation</mat-label
                                            >
                                            <mat-select
                                                formControlName="answer"
                                                class="form-control"
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let riskFactor of interviewQuestions[0]
                                                            ?.casRecommended
                                                            ?.options
                                                    "
                                                    [value]="riskFactor?.value"
                                                >
                                                    {{ riskFactor?.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-contianer>
                </div>
            </div>

            <div>
                <h2>Notes:</h2>
                <ol style="
                    list-style: decimal;
                    padding-inline-start: 15px;
                    margin-block-start: 5px;
                    font-weight: 500;
                  ">
                  <li>Why did you choose to study this course?</li>
                  <li>Which other institutions</li>
                  did you consider?
                  <li>Why did you choose this institution?</li>
                  <li>
                    How are the modules/ course content/ facilities suited to your
                    needs?
                  </li>
                  <li>
                    What are your future plans? and How will studying this course help
                    you achieve this?
                  </li>
                  <li>
                    What is your expected salary upon your return to your home country?
                  </li>
                  <li>What was the last course of study you completed and when?</li>
                  <li>What have you been doing since?</li>
                  <li>(if there has been a gap in</li>
                  studies) Why have you chosen to resume your studies?
                  <li>
                    (if applicant has been working since last course of study) What was
                    your monthly salary?
                  </li>
                  <li>How much will the course cost?</li>
                  <li>Who is funding your</li>
                  studies?
                  <li>What job does your financial sponsor do?</li>
                  <li>What is your financial sponsor’s income?</li>
                  <li>How many people are dependent upon</li>
                  their income?
                  <li>Where have the funds in your account come from?</li>
                  <li>Are the funds still there?</li>
                  <li>Where will you live whilst in the UK?</li>
                  <li>How much will your accommodation cost each month?</li>
                  <li>How will you travel to your place of study each day?</li>
                </ol>
              </div>

            <div class="row mt-10 py-4" formArrayName="decisionQuestions">
                <div
                    class="col-sm-12 px-4 py-4 bg-blue text-white fw-semibold fs-20"
                >
                    {{ decisionQuestionArr[0].primary.heading }}
                </div>
                <div
                    *ngFor="
                        let group of interviewForm.get('decisionQuestions')
                            .controls;
                        let m = index
                    "
                    [formGroupName]="m"
                >
                    <div class="row fw-semibold pb-5 py-4">
                        <label class="col-sm-4 label-center">
                            {{ decisionQuestionArr[0]?.questions[m]?.question }}
                            <b
                                class="color-red"
                                *ngIf="
                                    decisionQuestionArr[0]?.questions[m]
                                        ?.isRequired
                                "
                                >*</b
                            >
                        </label>
                        <div class="col-sm-6">
                            <div class="d-flex gap-x-2">
                                <ng-container
                                    *ngFor="
                                        let option of decisionQuestionArr[0]
                                            ?.questions[m].options
                                    "
                                >
                                    <input
                                        type="radio"
                                        [id]="option?.id"
                                        [value]="option?.value"
                                        formControlName="answer"
                                    />
                                    <label
                                        [for]="option?.id"
                                        class="cursor-pointer"
                                    >
                                        {{ option?.label }}
                                    </label>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <button type="submit">Submit</button> -->

            
        </form>
    </mat-card-content>
</mat-card>
